import React, { useState, Fragment } from "react";
import StudentGrid from "./StudentGrid";
import AverageScoreByBenchmarkCategory from "../dashboard/AverageScoreByBenchmarkCategory";
import OverallResultsProgression from "../dashboard/OverallResultsProgressionChart";
import ControlledTab from "../../layouts/ControlledTab";
import YearDropDown from "../../layouts/YearDropDown";
import PMResults from "../progressmonitoring/PMResults";
import PMAssessmentCreate from "../progressmonitoring/PMAssessmentCreate";
import PMDashboard from "../progressmonitoring/PMDashboard";
import { ListGroup } from "react-bootstrap";

const UserInfo = ({
  year,
  user,
  checked,
  userLoading,
  reportsLoading,
  reports,
  averageScorePerBenchmarkCategoryChart,
  overallResultsProgressionChart,
  isPMMode = null,
  filterData,
  setFilterData,
  handleApplyFilter,
  handleClearFilter,
  filtersApplied,
  showAppliedEffect,
  setIsPMMode,
}) => {
  const [schoolYears, setSchoolYears] = React.useState([]);

  const onTabChange = (k) => {
    if (k == "profile") {
      setIsPMMode(true);
    } else {
      setIsPMMode(false);
    }
  };

  return (
    <Fragment>
      {userLoading ? (
        <div className="card w-100 p-2 p-sm-3 p-lg-4 shadow-lg border-0  mb-2 vh-100 ">
          <div className="d-flex justify-content-center align-items-center h-100">
            <div class="spinner-border txt-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      ) : (
        <div className="card w-100 p-2 p-sm-3 p-lg-4 shadow-lg border-0 mb-2 col-12">
          <ControlledTab isPMMode={isPMMode} onTabChange={onTabChange} />
          <div className="row">
            <div className="col-12 col-lg-12 p-0">
              <h6 className="txt-primary">
                {year - 1}-{year}
              </h6>
            </div>
            {/* User info */}
            <div className="d-flex flex-column col-2">
              {user.AlternativeID !== null && (
                <div className="mb-3">
                  <div className="txt-primary">ID</div>
                  <div className="">{user.AlternativeID}</div>
                </div>
              )}
              <div className="mb-3">
                <div className="txt-primary">First Name</div>
                <div className="">{user.FirstName}</div>
              </div>
              <div className="mb-3">
                <div className="txt-primary">Last Name</div>
                <div className="">{user.LastName}</div>
              </div>
              {user.UserTypeID !== 5 && (
                <div className="mb-3">
                  <div className="txt-primary">School</div>
                  <div className="">{user.SchoolName}</div>
                </div>
              )}
              {user.UserTypeID !== 2 && (
                <div className="mb-3">
                  <div className="txt-primary">Email</div>
                  <div className="">{user.Email}</div>
                </div>
              )}
              <div className="mb-3">
                <div className="txt-primary">Role</div>
                <div className=""> {user.UserType}</div>
              </div>
              <div className="mb-3">
                <div className="txt-primary">Grade</div>
                <div className="">
                  {reports.length > 0 ? reports[0].Grade : "N/A"}
                </div>
              </div>
              <div className="mb-3">
                <div className="txt-primary">Created Date</div>
                <div className="">
                  {" "}
                  {user.CreatedDate !== undefined && user.CreatedDate !== null
                    ? new Date(user.CreatedDate).toLocaleString("en-US", {
                        year: "numeric",
                        day: "2-digit",
                        month: "long",
                      })
                    : new Date().toLocaleString("en-US", {
                        year: "numeric",
                        day: "2-digit",
                        month: "long",
                      })}
                </div>
              </div>
            </div>
            {/* Progression of Overall Results By Assessment Type */}
            {parseInt(user.UserTypeID) == 2 && !isPMMode && (
              <>
                <div className="col-10">
                  {!checked ? (
                    <AverageScoreByBenchmarkCategory
                      chartData={averageScorePerBenchmarkCategoryChart}
                      calculationType={1} // 1: Percentile, 0: Benchmark Status
                    />
                  ) : (
                    <AverageScoreByBenchmarkCategory
                      chartData={averageScorePerBenchmarkCategoryChart}
                      calculationType={0} // 1: Percentile, 0: Benchmark Status
                    />
                  )}
                </div>
              </>
            )}
          </div>

          {/* Navigation Tab between Module  */}
          {parseInt(user.UserTypeID) == 2 && (
            <div className="d-flex flex-column justify-content-end align-items-start my-3">
              {!isPMMode ? (
                <StudentGrid
                  reports={reports}
                  reportsLoading={reportsLoading}
                  filterData={filterData}
                  setFilterData={setFilterData}
                  handleApplyFilter={handleApplyFilter}
                  handleClearFilter={handleClearFilter}
                  filtersApplied={filtersApplied}
                  showAppliedEffect={showAppliedEffect}
                />
              ) : (
                <>
                  {/* Monitoring toolbar */}
                  <div className="w-100 d-flex justify-content-end align-items-center">
                    {/* <div className="txt-primary">Student Results</div>
                    <div className="w-100 d-flex justify-content-end align-items-center">
                      
                      // Year Filter
                      <div className="p-0 mx-2" style={{ maxWidth: "200px" }}>
                        <select
                          className="form-select form-control bg-primary text-white m-0"
                          aria-label="Default select example"
                          value={
                            schoolYears.length > 0
                              ? schoolYears[0].SchoolYear
                              : -1
                          }
                          id="year"
                          onChange={(e) =>
                            setSchoolYears(parseInt(e.target.value))
                          }
                        >
                          <option value={-1}>All Years</option>
                          <YearDropDown schoolYears={schoolYears} />
                        </select>
                      </div>

                      // Prop Filter
                      <div className="p-0 mx-2" style={{ maxWidth: "200px" }}>
                        <select
                          className="form-select form-control bg-primary text-white m-0"
                          aria-label="Default select example"
                          value={
                            schoolYears.length > 0
                              ? schoolYears[0].SchoolYear
                              : -1
                          }
                          id="year"
                          onChange={(e) => console.log(e.target.value)}
                        >
                          <option value={-1}>Select a probe</option>
                          <option value={-1}>Probe 1</option>
                          <option value={-1}>Probe 2</option>
                          <option value={-1}>Probe 3</option>
                          <option value={-1}>Probe 4</option>
                          <option value={-1}>Probe 5</option>
                          <option value={-1}>Probe 6</option>
                          <option value={-1}>Probe 7</option>
                          <option value={-1}>Probe 8</option>
                          <option value={-1}>Probe 9</option>
                          <option value={-1}>Probe 10</option>
                          <option value={-1}>Probe 11</option>
                          <option value={-1}>Probe 12</option>
                          <option value={-1}>Probe 13</option>
                          <option value={-1}>Probe 14</option>
                          <option value={-1}>Probe 15</option>
                          <option value={-1}>Probe 16</option>
                          <option value={-1}>Probe 17</option>
                          <option value={-1}>Probe 18</option>
                          <option value={-1}>Probe 19</option>
                          <option value={-1}>Probe 20</option>
                        </select>
                      </div>

                      // Probe Filter
                      <div className="p-0 mx-2" style={{ maxWidth: "200px" }}>
                        <select
                          className="form-select form-control bg-primary text-white m-0"
                          aria-label="Default select example"
                          value={
                            schoolYears.length > 0
                              ? schoolYears[0].SchoolYear
                              : -1
                          }
                          id="year"
                          onChange={(e) => console.log(e.target.value)}
                        >
                          <option value={-1}>Select a level</option>
                          <option value={-1}>Level 1</option>
                          <option value={-1}>Level 2</option>
                          <option value={-1}>Level 3</option>
                          <option value={-1}>Level 4</option>
                          <option value={-1}>Level 5</option>
                          <option value={-1}>Level 6</option>
                          <option value={-1}>Level 7</option>
                          <option value={-1}>Level 8</option>
                        </select>
                      </div>

                      // Search bar
                      <Search
                        // setListSearch={setListSearch}
                        // setSearch={setSearch}
                        // filter={(e) => {
                        //   setIcons({
                        //     school: 0,
                        //     createdDate: 0,
                        //     year: 0,
                        //     benchmark: 0,
                        //     category: 0,
                        //     title: 0,
                        //     grade: 0,
                        //     percentile: 0,
                        //     teacher: 0,
                        //   });
                        //   return searchInput(
                        //     filterInput(formatReports(reports), formData),
                        //     e.target.value,
                        //   );
                        // }}
                      />

                      // Filter Bar
                      <StudentFilter
                        // setFilter={setFilter}
                        // setListSearch={setListSearch}
                        // formatReports={formatReports}
                        // reports={reports}
                        // formData={formData}
                        // setFormData={setFormData}
                        // searchInput={searchInput}
                        // search={search}
                      />
                    </div>
                  */}
                  </div>
                  <div className="card w-100 p-2 p-sm-3 p-lg-4 shadow-lg border-0  my-3">
                    <h6 className="txt-primary-light">Monitoring Board</h6>
                    <PMDashboard />
                  </div>
                  <div className="card w-100 p-2 p-sm-3 p-lg-4 shadow-lg border-0  my-3">
                    <h6 className="txt-primary-light">
                      Assigned Progress Monitoring
                    </h6>
                    <div className="w-100 d-flex justify-content-between g-4">
                      <div className="w-70 d-flex flex-column overflow-auto">
                        <div className="w-100">
                          <PMResults />
                        </div>
                      </div>

                      <div className="w-30 d-flex flex-column">
                        <PMAssessmentCreate />
                        {/* Legend: Steps to Progress Monitor - styled to match PMAssessmentCreate */}
                        <div className="container card max-auto mt-4 border-0">
                          <div className="card-body shadow p-4">
                            <ListGroup>
                              <ListGroup.Item className="p-0">
                                {/* Section Header & Description - matches "Assessment Assignment" header */}
                                <div className="px-3 py-1 border-bottom bg-primary text-white">
                                  <h6 className="mt-2">
                                    Steps to Progress Monitor
                                  </h6>
                                  <p className="mt-2 mb-2">
                                    Follow these steps to determine where to
                                    start and how to progress.
                                  </p>
                                </div>

                                {/* To Start */}
                                <div className="row g-3 p-3 mb-1">
                                  <div className="col-md-12">
                                    <label>
                                      <b>To Start</b>
                                    </label>
                                    <ul className="ps-3 mb-0 mt-1">
                                      <li>
                                        Student in Grade 3 and up,{" "}
                                        <strong>START</strong> 2 grade levels
                                        below current grade on Story Reading
                                      </li>
                                      <li>
                                        Student in Grade 2,{" "}
                                        <strong>START</strong> with Level 1
                                        Story Reading
                                      </li>
                                      <li>
                                        Student in Grade 1{" "}
                                        <strong>START</strong> with Level 1
                                        Silly Words
                                      </li>
                                      <li>
                                        Student in Kindergarten{" "}
                                        <strong>START</strong> with Level K
                                        Letter Sounds
                                      </li>
                                    </ul>
                                    &nbsp;
                                    <p className="fw-bold text-right mt-2 mb-0">
                                      ONLY ADMINISTER 1 PROBE.
                                    </p>
                                  </div>
                                </div>

                                {/* Next Steps */}
                                <div className="row g-3 p-3 mb-1">
                                  <div className="col-md-12">
                                    <label>
                                      <b>Next Steps</b>
                                    </label>
                                    <p className="mt-1 mb-2">
                                      For students in Grade 2 and up continue
                                      testing down 2 levels until they score{" "}
                                      <span className="bg-success bg-opacity-25 fw-bold px-1 rounded">
                                        AT BENCHMARK
                                      </span>
                                      , or until they get to Level 1.
                                    </p>
                                    <p className="mb-2">
                                      Grade 1 or below continue testing down in
                                      skills in the following order:
                                    </p>

                                    <div className="d-flex flex-column align-items-center">
                                      {[
                                        "Silly Words",
                                        "Break Up The Word",
                                        "Say The First Sound",
                                        "Letter Sounds",
                                        "Name the Letter",
                                      ].map((step, i, arr) => (
                                        <React.Fragment key={step}>
                                          <div className="border rounded px-3 py-1 text-center w-100 bg-light">
                                            {step}
                                          </div>
                                          {i < arr.length - 1 && (
                                            <div className="fs-5 lh-1 text-success">
                                              ↓
                                            </div>
                                          )}
                                        </React.Fragment>
                                      ))}
                                    </div>
                                  </div>
                                </div>

                                {/* Footer note */}
                                <div className="row g-3 p-3 mb-2">
                                  <div className="col-md-12">
                                    <p className="fw-bold mb-0 text-center">
                                      Progress Monitor on the identified skill.
                                      Only progress monitor on one skill at a
                                      time.
                                    </p>
                                  </div>
                                </div>
                              </ListGroup.Item>
                            </ListGroup>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      )}
    </Fragment>
  );
};

export default UserInfo;
